import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, NormalizedCacheObject, Operation } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';

import { getTokenCookie } from '@shared/lib';

const CONFIG_FLAGS_GRAPHQL_PATH = '/feature-flags/graphql';

const getConfigFlagsWsUrl = (): string => {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';

  return `${protocol}//${window.location.host}${CONFIG_FLAGS_GRAPHQL_PATH}`;
};

const authLink = setContext((_, { headers }) => {
  const token = getTokenCookie();

  return {
    headers: {
      ...headers,
      ...(token ? { authorization: `Bearer ${token}` } : {}),
    },
  };
});

const httpLink = new HttpLink({ uri: CONFIG_FLAGS_GRAPHQL_PATH });

const configFlagsWsClient = createClient({
  url: getConfigFlagsWsUrl(),
  connectionParams: () => {
    const token = getTokenCookie();

    return token ? { authorization: `Bearer ${token}` } : {};
  },
});

const wsLink = new GraphQLWsLink(configFlagsWsClient);

export const disposeConfigFlagsWsClient = (): void => {
  configFlagsWsClient.dispose();
};

const isSubscriptionOperation = (operation: Operation) => {
  const definition = getMainDefinition(operation.query);

  return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
};

const splitLink = ApolloLink.split(isSubscriptionOperation, wsLink, authLink.concat(httpLink));

export const configFlagsApolloClient: ApolloClient<NormalizedCacheObject> = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
});
